// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './forgot-password-success.scss';

function ForgotPasswordSuccess({ onReset, resetForm }) {
    return (
        <div className="forgot-password-success">
            <h3>Request Received</h3>
            <p>
                If the user name entered matches user records, password reset link will be emailed. Click{' '}
                <button
                    className="forgot-password-success--link-button"
                    onClick={(event) => {
                        resetForm();
                        onReset(event);
                    }}
                >
                    here
                </button>{' '}
                to go back to login page.
            </p>
        </div>
    );
}

ForgotPasswordSuccess.propTypes = {
    onReset: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
};

export default ForgotPasswordSuccess;
